import script from "./NetSuiteCurrencyMapping.vue?vue&type=script&setup=true&lang=js"
export * from "./NetSuiteCurrencyMapping.vue?vue&type=script&setup=true&lang=js"

import "./NetSuiteCurrencyMapping.vue?vue&type=style&index=0&id=0c99f8a0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c99f8a0"]])

export default __exports__